import(/* webpackMode: "eager" */ "/root/iyiwutrade/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/root/iyiwutrade/src/app/(industrialBelt)/layout.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/iyiwutrade/src/components/header/IndustrialBeltHeader.js");
